import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const SectionLabel = ({ children, index }) => (
  <div className="flex items-center gap-4">
    {index && (
      <span className="font-heading text-xs tracking-[0.3em] text-[#777777]">{index}</span>
    )}
    <span className="h-px w-10 bg-[#111111]" />
    <span className="font-heading text-xs uppercase tracking-[0.3em] text-[#111111]">{children}</span>
  </div>
);

export const PrimaryButton = ({ to, children, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="group inline-flex items-center gap-2 bg-[#111111] px-8 py-4 font-heading text-sm uppercase tracking-[0.18em] text-white transition-colors hover:bg-[#333333]"
  >
    {children}
    <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Link>
);

export const SecondaryButton = ({ to, children, testid }) => (
  <Link
    to={to}
    data-testid={testid}
    className="group inline-flex items-center gap-2 border border-[#111111] px-8 py-4 font-heading text-sm uppercase tracking-[0.18em] text-[#111111] transition-colors hover:bg-[#111111] hover:text-white"
  >
    {children}
    <ArrowUpRight size={18} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
  </Link>
);
